import { Avatar } from "antd";
import Icon from "../../components/Icon/Icon";
import AvatarView from "../../components/_shared/AvatarView";
import dateUtils from "../../utils/dateUtils";
import globalUtils from "../../utils/globalUtils";
import clapUtils from "../../utils/clapUtils";
import { CurrencySymbol, Status } from "../constant";
import { ICellRender } from "./types";

const cells = {
  TextCell: function TextCell({ value }: ICellRender) {
    return <div>{value}</div>;
  },
  primaryColoredCell: function primaryColoredCell({ value }: ICellRender) {
    return <div className="text-ant-primary">{value}</div>;
  },
  FileIconCell: function FileIconCell({ value }: ICellRender) {
    return (
      <div className="flex items-center gap-x-2">
        <Icon icon="draft" className="h-[17px] w-[17px] opacity-70" />
        <div>{value}</div>
      </div>
    );
  },
  DateCell: function DateCell({ value }: ICellRender) {
    return <div>{dateUtils.defaultFormat(value)}</div>;
  },
  FileSizeCell: function FileSizeCell({ value }: ICellRender) {
    return <div>{value} KB</div>;
  },
  UploadStatusCell: function UploadStatusCell({ value }: ICellRender) {
    return (
      <div className="flex">
        <div
          className={`${clapUtils.getUploadStatusColor(
            value,
          )} text-white rounded-sm px-2`}
        >
          <div className="capitalize">
            {value.charAt(0) + value.slice(1).toLowerCase()}
          </div>
        </div>
      </div>
    );
  },
  MusicIconCell: function MusicIconCell({ value }: ICellRender) {
    return (
      <div className="flex items-center gap-x-[9px]">
        <Icon
          icon="music"
          className="h-4 w-4 min-h-[16px] min-w-[16px] opacity-70"
        />
        <div>{value}</div>
      </div>
    );
  },
  LinkCell: function LinkCell({ value }: ICellRender) {
    if (value)
      return (
        <a
          href={value}
          className="underline hover:underline text-ant-primary"
          target="_blank"
          rel="noreferrer"
        >
          Link
        </a>
      );
  },
  RoleCell: function RoleCell({ value }: ICellRender) {
    return <div>{globalUtils.snakeCaseToCapitalize(value[0])}</div>;
  },
  StatusCell: function StatusCell({ value }: ICellRender) {
    return (
      <div className="flex">
        <div
          className={`${
            value === Status.ACTIVE ? "bg-dodger-blue" : "bg-auro-metal-aurus"
          } text-white rounded-sm px-2`}
        >
          {globalUtils.snakeCaseToCapitalize(value)}
        </div>
      </div>
    );
  },
  SignupStatusCell: function SignupStatusCell({ value }: ICellRender) {
    return clapUtils.getSignupStatusType(value);
  },
  UserAvatarCell: function UserAvatarCell({ value, record }: ICellRender) {
    return this.AvatarCell(record?.profile_picture, value);
  },
  ClientLogoCell: function ClientLogoCell({ value, record }: ICellRender) {
    return this.AvatarCell(record?.client_logo, value);
  },
  ClientNameCell: function ClientNameCell({ value }: ICellRender) {
    return value && value;
  },
  AvatarCell: function AvatarCell(photo: any, value: any) {
    if (value)
      return (
        <div className="flex items-center gap-2.5">
          <AvatarView photo={photo} />
          <div>{value}</div>
        </div>
      );
  },
  LabelCell: function LabelCell({ value, record }: ICellRender) {
    return (
      <div className="flex items-center gap-2.5">
        {value &&
          (globalUtils.isPhotoExist(record?.logo) ? (
            <Avatar size="small" src={record.logo} />
          ) : (
            <Icon
              icon="radio_checked"
              className="h-4 w-4 text-secondary ml-[3px] mr-[4px]"
            />
          ))}
        <div>{value}</div>
      </div>
    );
  },
  MultiplePercentageTagCell: function MultiplePercentageTagCell({
    value,
    record,
  }: ICellRender) {
    return clapUtils.getIncomeShare(value, record.client_types);
  },
  PercentageTagCell: function PercentageTagCell({ value }: ICellRender) {
    return (
      <div className="flex flex-wrap">
        {value !== "" ? (
          <div className="bg-flash-white rounded-full px-2">{value}%</div>
        ) : (
          <div>{value}</div>
        )}
      </div>
    );
  },
  ClientTypesCell: function ClientTypesCell({ value }: ICellRender) {
    return clapUtils.getClientTypes(value);
  },
  PaymentStatusCell: function PaymentStatusCell({ value }: ICellRender) {
    return clapUtils.getPaymentType(value);
  },
  InvoiceStatusCell: function InvoiceStatusCell({ value }: ICellRender) {
    return clapUtils.getInvoiceType(value);
  },
  BDTCell: ({ value }: ICellRender) =>
    `${value !== "Not Converted" ? CurrencySymbol.BDT : ""} ${value || 0}`,
  EURCell: ({ value }: ICellRender) => `${CurrencySymbol.EUR} ${value || 0}`,
  USDCell: ({ value }: ICellRender) => `${CurrencySymbol.USD} ${value || 0}`,
  TotalDueCell: ({ record }: ICellRender) =>
    `${CurrencySymbol.BDT} ${record.total_bdt_due || 0} / ${
      CurrencySymbol.EUR
    } ${record.total_euro_due || 0} / ${CurrencySymbol.USD} ${
      record.total_usd_due || 0
    }`,
  InvoiceNoCell: function InvoiceNoCell({ value }: ICellRender) {
    return <div className="text-ant-primary">{value}</div>;
  },
  ExchangeRateCell: function ExchangeRateCell({ value }: ICellRender) {
    return value && <div>@{value}</div>;
  },
  InvoiceAmountCell: function InvoiceAmountCell({
    value,
    record,
  }: ICellRender) {
    return (
      <div>
        {value && `${clapUtils.getCurrencyIcon(record.currency)} ${value}`}
      </div>
    );
  },
};

export default cells;
